<template>
  <div>
    <div :class="`min-h-screen ${!dashboard ? 'pt-16' : ''}`">
      <div
        class="container md:px-12 sm:pt-4 md:pt-10 pb-6 flex flex-col items-center justify-center"
      >
        <template v-if="state === 'review'">
          <div><CompleteAndUnderReview /></div
        ></template>
        <template v-else-if="state.includes('applicationBlocked')">
          <NerSubmitted v-if="state.includes('NER')"></NerSubmitted>
          <!-- <h1 class="text-default text-center text-lg font-light pb-4">
              We are sorry, but we are unable to offer you a loan at this time.
              <span class="font-black">{{ rejectionReason }} </span> <br /><br />
              You can apply again after 30 days. If you think this was a due to a mistake in your
              application input, give us a call at
              <a href="tel:6786858834" class="underline">+1 (678) 685-8834</a>
            </h1> -->
          <ApplicationBlocked v-else> </ApplicationBlocked>
        </template>
        <template v-else>
          <h1
            v-if="state === 'signed'"
            class="text-center text-xl font-semibold text-default pt-6 md:px-5 pb-4"
          >
            You have already signed your loan agreement, which is currently under final review. Your
            loan should be on it's way soon!
          </h1>

          <h1
            v-else-if="state === 'originated'"
            class="text-center text-xl font-semibold text-default pb-4"
          >
            You already have an outstanding loan! VIVA only allows one outstanding loan at a time,
            per-person.
          </h1>
          <template v-else-if="state === 'rejected'">
            <!-- <h1 class="text-default text-center text-lg font-light pb-4">
              We are sorry, but we are unable to offer you a loan at this time.
              <span class="font-black">{{ rejectionReason }} </span> <br /><br />
              You can apply again after 30 days. If you think this was a due to a mistake in your
              application input, give us a call at
              <a href="tel:6786858834" class="underline">+1 (678) 685-8834</a>
            </h1> -->
            <NotApproved> </NotApproved>
          </template>

          <h1
            v-else-if="state === 'review'"
            class="text-center md:text-xl font-semibold text-default pb-4"
          >
            Your Loan Application is Complete and Under Review.
          </h1>
          <h1
            v-else-if="!loading && state"
            class="text-center md:text-xl font-semibold text-default pb-4"
          >
            You do not have an outstanding loan, and have not completed the loan application
            process.
          </h1>

          <h2 v-if="state === 'signed'" class="text-center md:px-20 text-gray-600">
            You will be notified via email when your loan has been originated and the money is on
            it's way to your account. If you did not apply for this loan, and believe this is a
            mistake, please contact our
            <router-link to="/support" class="text-blue-500 hover:text-secondary"
              >Customer Support</router-link
            >.
          </h2>
          <h2 v-else-if="state === 'originated'" class="text-center md:px-8 text-gray-600">
            Once your loan is fully paid-off, you will be able to apply for another loan from VIVA.
            If you did not apply for this loan, and believe this is a mistake, please contact our
            <router-link to="/support" class="text-blue-500 hover:text-secondary"
              >Customer Support</router-link
            >.
          </h2>
          <h2
            v-else-if="state === 'rejected' && !dashboard"
            class="text-center md:px-8 text-gray-600"
          >
            We are sorry, but we are unable to offer you a loan at this time. You can apply again 30
            days from the original application. If you have any questions, please contact
            <router-link to="/support" class="text-blue-500 hover:text-secondary"
              >Customer Support</router-link
            >
            and a VIVA representative will get back to you shortly.
          </h2>
          <h1
            v-else-if="state === 'rejected' && dashboard"
            class="text-default text-center text-xl font-semibold"
          ></h1>
          <h2 v-else-if="state === 'review'" class="text-center md:px-20 text-gray-600">
            Please allow an average of 1-2 business days for your application to be processed. You
            will then receive an email from VIVA Finance with the outcome of your application.
          </h2>
          <h2
            v-else-if="!loading && state"
            class="text-center md:px-8 text-sm md:text-base text-gray-600"
          >
            You can view these pages once you've completed our loan application process, and signed
            your loan agreement. If you already applied for a loan, and believe there is a mistake,
            please contact our
            <router-link to="/support" class="text-blue-500 hover:text-secondary"
              >Customer Support</router-link
            >.
          </h2>

          <img
            v-if="!loading && state !== 'rejected'"
            alt="img"
            :src="require(`@/assets/img/sketches/${sketch}.svg`)"
            class="w-4/5 md:w-1/3 my-4"
          />
          <!-- <img
            v-if="state === 'rejected' && dashboard"
            alt="img"
            :src="require('@/assets/img/sketches/rejection_image.svg')"
            class="md:w-1/3 my-4"
          /> -->
          <iframe
            v-if="state === 'rejected' && !dashboard"
            title="Do Not Qualify"
            src="https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Notice+of+Adverse+Action.pdf"
            class="hidden md:block my-5 block w-full"
            style="height: 800px"
          ></iframe>
          <div v-if="state === 'rejected' && !dashboard" class="md:hidden bg-gray-700 p-1 my-5">
            <a
              target="_blank"
              rel="noopener"
              href="https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Notice+of+Adverse+Action.pdf"
              class="focus:outline-none"
              ><img src="img/misc/AdverseAction.png" alt="img"
            /></a>
          </div>

          <div class="flex md:flex-row flex-col items-center justify-center">
            <router-link
              v-if="!loading && state !== 'review' && state !== 'rejected' && showDashboardLink"
              to="/dashboard"
              class="mx-4 flex items-center text-gray-500 hover:text-blue-500"
              ><i class="fas fa-arrow-left mr-2 my-2"></i> Return to Dashboard</router-link
            >
            <!-- <router-link
            v-if="state === 'signed'"
            to="/loan"
            class="mx-4 text-center border-primary text-white bg-primary p-2 rounded hover:shadow-md bg-gray-100 my-2"
            ><span class="text-white"
              >View your loan agreement<i class="fas fa-arrow-right ml-2 my-2"></i></span
          ></router-link> -->

            <router-link
              v-if="state === 'originated'"
              to="/loan"
              class="mx-4 text-center border-primary btn base-button flex-none btn ml-3 btn-primary text-white bg-primary p-2 rounded hover:shadow-md my-2"
              ><span class="text-white"
                >View your outstanding loan<i class="fas fa-arrow-right ml-2 my-2"></i></span
            ></router-link>
            <p v-else-if="state === 'review'"></p>
            <router-link
              v-else-if="$store.getters.applicationStep === 'Offer Sent' && !$store.getters.ddSetUp"
              to="/apply/offerDetails"
              class="mx-4 text-center border-primary btn base-button flex-none btn ml-3 btn-primary text-white bg-primary p-2 rounded hover:shadow-md my-2"
              ><span class="text-white"
                >View your offer<i class="fas fa-arrow-right ml-2 my-2"></i></span
            ></router-link>
            <router-link
              v-else-if="!loading && state !== 'rejected' && state !== 'signed'"
              to="/apply"
              class="mx-4 text-center btn btn-primary border-primary text-white bg-primary p-2 rounded hover:shadow-md my-2"
              ><span class="text-white"
                >{{ state === 'not-started' ? 'Start' : 'Continue' }} your loan application<i
                  class="fas fa-arrow-right ml-2 my-2"
                ></i></span
            ></router-link>
            <p v-else />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import CompleteAndUnderReview from '@/components/ApplicationFlow/CompleteAndUnderReview'
import NotApproved from '@/views/Pages/NotApproved'
import NerSubmitted from '@/views/Pages/NerSubmitted'
import ApplicationBlocked from '@/components/ApplicationFlow/ApplicationBlocked'

export default {
  name: 'Restricted',
  props: {
    showDashboardLink: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CompleteAndUnderReview,
    NotApproved,
    ApplicationBlocked,
    NerSubmitted
  },
  data() {
    return {
      error: '',
      comment: '',
      hover: 0,
      loading: true,
      state: '',
      rating: 0,
      rates: false
    }
  },
  computed: {
    dashboard() {
      return !this.$route.path.includes('_restricted')
    },
    sketch() {
      if (this.state === 'signed') {
        return 'signed'
      } else if (this.state === 'originated') {
        return 'already'
      } else if (this.state === 'review') {
        return 'review'
        // } else if (this.state === 'in-progress') {
        //   return 'in-progress'
      } else if (this.state === 'rejected') {
        return ''
      } else {
        return 'customizeLoan'
      }
    },
    rejectionReason() {
      console.log(this.$store.state.applicationData.rejectionReason)
      let rejectionMessage = ''
      if (this.$store.state.applicationData.rejectionReason === 'shortTenure') {
        rejectionMessage =
          "VIVA requires that you have been at your job for at least one year consecutively. In addition, VIVA's loan program is only available to full-time employees."
      } else if (this.$store.state.applicationData.rejectionReason === 'partTime') {
        rejectionMessage = "VIVA's loan program is only available to full-time employees."
      } else if (this.$store.state.applicationData.rejectionReason === 'activeMilitary') {
        rejectionMessage =
          'Due to rules and restrictions within the Military Lending Act, loans offered by VIVA Finance are not available to active duty service members or their spouses.'
      } else if (this.$store.state.applicationData.rejectionReason === 'lowIncome') {
        rejectionMessage =
          'Your net take-home pay from your primary employer is insufficient to cover the repayment costs of a loan.'
      } else if (this.$store.state.applicationData.rejectionReason === 'lowCredit') {
        rejectionMessage = 'Your credit Score does not meet our minimum requirements for a loan.'
      } else if (this.$store.state.applicationData.rejectionReason === 'payrollLenderPastDue') {
        rejectionMessage = 'You are past due on a loan with a payroll-linked lender.'
      } else if (this.$store.state.applicationData.rejectionReason === 'payrollLenderRecentLoan') {
        rejectionMessage = 'You have recently taken out a loan with another payroll-linked lender.'
      }
      return rejectionMessage
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$apiClient
        .mutate({
          mutation: gql(`mutation { rates(comment: "${this.comment || 'NONE'}", rating: ${
            this.rating
          }) {
          comment
          rating
        } }`)
        })
        .then(({ data }) => {
          setTimeout(() => {
            this.loading = false
            window.location.replace('/#/loan')
            window.location.reload(true)
          }, 250)
        })
        .catch((e) => {
          this.error = e
          this.loading = false
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loading = this.$store.state.signingIn
      this.state = this.$store.getters.loanState
    })
  },
  watch: {
    loading() {
      this.$nextTick(() => {
        this.state = this.$store.getters.loanState
      })
    },
    state(state) {
      if (state === 'review' && !this.$store.state.rating.rating) {
        setTimeout(() => {
          this.rates = state === 'review' && this.$store.state.rating.rating === 0
        }, 3000)
      }
    },
    '$store.getters.loanState': function (state) {
      this.state = state
    },
    '$store.state.rating': function (rating) {
      if (rating.rating > 0) {
        this.rates = false
      }
    },
    '$store.state.signingIn': function (signingIn) {
      this.$nextTick(() => {
        this.loading = signingIn
      })
    }
  }
}
</script>
